export default __webpack_public_path__ + "static/HelveticaNeueLTStd-Roman-41833cf0d2ff7ab2a686bc63122a19b6.otf";